import React from "react";

const OnSide = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <div className="text-sm text-gray-600 mb-4">
        <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Yerinde Yıkama
      </div>

      <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">ANKARA YERİNDE YIKAMA HİZMETİ</h1>

      <div className="space-y-6">
        <p>
          Abone Halı Yıkama olarak, ev veya iş yerlerinizde yerinde temizlik hizmeti sunuyoruz. Halı, koltuk, yatak ve perde gibi taşınması zor eşyalarınızı yerinde, profesyonel ekipman ve ürünlerle hijyenik şekilde temizliyoruz.
        </p>

        <p>
          Ankara genelinde sunduğumuz yerinde yıkama hizmetimiz sayesinde eşyalarınızı taşımadan, yerinden sökmeden temizlik işlemlerini gerçekleştirebilirsiniz. Böylece hem zaman kazanır hem de temizlik sonrası düzeninizi bozmamış olursunuz.
        </p>

        <p>
          Uzman ekibimiz, yüksek emiş gücüne sahip sanayi tipi makineler ve özel temizlik ürünleri ile bulunduğunuz mekânda etkili bir temizlik sağlar. Yıkama sonrası hızlı kuruma sistemi sayesinde günlük hayatınıza kesintisiz devam edebilirsiniz.
        </p>

        <p>
          Hizmetten yararlanmak için WhatsApp hattımızdan veya çağrı merkezimizden hemen randevu alabilirsiniz. Ekibimiz en kısa sürede adresinize ulaşır ve yerinde temizlik işlemini başlatır.
        </p>

        <h2 className="text-xl font-bold text-[#003132]">🚪 Yerinde Yıkama Neleri Kapsar?</h2>
        <ul className="list-disc list-inside">
          <li>Koltuk ve kanepe temizliği</li>
          <li>Yatak temizliği</li>
          <li>Sandalyeli oturma grupları</li>
          <li>Duvara sabit halılar ve halıfleksler</li>
          <li>Perde ve tül temizliği (yerinde buhar ve köpük uygulaması)</li>
        </ul>

        <h2 className="text-xl font-bold text-[#003132]">💧 Yerinde Yıkama Sürecimiz</h2>
        <ol className="list-decimal list-inside space-y-2">
          <li>Adresinize ulaşım ve detaylı keşif</li>
          <li>Kumaş veya zemin türüne göre uygun ürün seçimi</li>
          <li>Leke analizi ve ön temizlik</li>
          <li>Sanayi tipi makinelerle derinlemesine temizlik</li>
          <li>Durulama ve güçlü vakum sistemiyle kurutma</li>
          <li>Son kontrol ve işlem sonrası bilgilendirme</li>
        </ol>

        <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
        <ul className="list-disc list-inside">
          <li>Yüzeye zarar vermeyen, bitkisel içerikli temizleyiciler</li>
          <li>Antibakteriyel ve antialerjik temizlik ürünleri</li>
          <li>Koku giderici ve dezenfekte edici solüsyonlar</li>
        </ul>

        <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
        <ul className="list-disc list-inside">
          <li>Taşıma zahmeti olmadan hizmet</li>
          <li>Yerinde hızlı ve etkili temizlik</li>
          <li>Modern makineler ve tecrübeli ekip</li>
          <li>Hijyen garantili sonuç</li>
          <li>Uygun fiyat ve zamanında hizmet</li>
        </ul>

        <p>
          Yerinde yıkama hizmetimiz ile konforunuzu bozmadan hijyenik çözümler sunuyoruz. Kaliteli ve güvenilir temizlik için bize ulaşmanız yeterlidir. Randevu alın, biz ayağınıza gelelim!
        </p>
      </div>
    </div>
  );
};

export default OnSide;
